import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Images from './Content/Images'
import Video from './Content/Video'
import { baseURLPublic } from '../../../config/BaseUrl'
import Gifs from './Content/Gifs'
import All from './Content/All'

function SlideShow() {

  const { id } = useParams()

  const [galleryItems, setGalleryItems] = useState([])

  

  useEffect(() => {
    baseURLPublic.get(`social-gallery-slider/${id}`)
      .then(res => {
        setGalleryItems(res.data.gallery_items)
      })
      .catch(err => {
        console.log(err)
      })
  }, [])



  const fullScreen = (element) => {
    if (
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement
    ) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    } else {
      
      if (element.current.requestFullscreen) {
        element.current.requestFullscreen();
      } else if (element.current.mozRequestFullScreen) {
        element.current.mozRequestFullScreen();
      } else if (element.current.webkitRequestFullscreen) {
        element.current.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
      } else if (element.current.msRequestFullscreen) {
        element.current.msRequestFullscreen();
      }
    }
  }



  return (
    <div className="slide-show-page">
      <nav className="slider-page-header">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-link active" id="nav-all-tab" data-toggle="tab" href="#nav-all" role="tab" aria-controls="nav-all" aria-selected="false">All</a>
          <a class="nav-link" id="nav-contact-tab" data-toggle="tab" href="#nav-contact" role="tab" aria-controls="nav-contact" aria-selected="false">Photos</a>
          <a class="nav-link" id="nav-profile-tab" data-toggle="tab" href="#nav-profile" role="tab" aria-controls="nav-profile" aria-selected="false">Gifs</a>
          <a class="nav-link" id="nav-home-tab" data-toggle="tab" href="#nav-home" role="tab" aria-controls="nav-home" aria-selected="true">Videos</a>
        </div>
      </nav>
      <div class="tab-content" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-all" role="tabpanel" aria-labelledby="nav-all-tab">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <All galleryItems={galleryItems} fullScreen={fullScreen} />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-contact" role="tabpanel" aria-labelledby="nav-contact-tab">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Images photos={galleryItems.filter(item => item.media_type === 'photo')} fullScreen={fullScreen} />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Gifs gifs={galleryItems.filter(item => item.media_type === 'boomerang')} fullScreen={fullScreen} />
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-home" role="tabpanel" aria-labelledby="nav-home-tab">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <Video videos={galleryItems.filter(item => item.media_type === 'video')} fullScreen={fullScreen} />
              </div>
            </div>
          </div>
        </div>
        
        
        
      </div>
    </div>
  )
}

export default SlideShow
